import { NavLink } from 'react-router';
import { FileText, HelpCircle, Image, LayoutTemplate } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface Pestana {
  a: string;
  etiqueta: string;
  icono: LucideIcon;
}

const PESTANAS: Pestana[] = [
  { a: '/portal/preguntas-frecuentes', etiqueta: 'Preguntas frecuentes', icono: HelpCircle },
  { a: '/portal/banners', etiqueta: 'Banners', icono: Image },
  { a: '/portal/footer', etiqueta: 'Pie de página', icono: LayoutTemplate },
  { a: '/portal/documentos-legales', etiqueta: 'Documentos legales', icono: FileText },
];

export function PestanasDelPortal() {
  return (
    <nav
      aria-label="Áreas del portal ciudadano"
      className="mb-6 flex gap-1 overflow-x-auto border-b border-armazon-200"
    >
      {PESTANAS.map(({ a, etiqueta, icono: Icono }) => (
        <NavLink
          key={a}
          to={a}
          className={({ isActive }) =>
            [
              'flex shrink-0 items-center gap-2 border-b-2 px-4 py-3 text-[13px] font-semibold uppercase tracking-wide transition-colors',
              isActive
                ? 'border-marca-500 text-armazon-900'
                : 'border-transparent text-armazon-400 hover:text-armazon-600',
            ].join(' ')
          }
        >
          {({ isActive }) => (
            <>
              <Icono
                className={`size-4 shrink-0 ${isActive ? 'text-marca-500' : ''}`}
                aria-hidden
              />
              {etiqueta}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
